import { ActionType, ActionTypes } from '../actionTypes';
import { AlertsState } from '../types';

const initialState: AlertsState = {
  alertsById: new Map(),
  alertsByLocationId: new Map(),
};

// eslint-disable-next-line default-param-last
export default function setAlertsState(state = initialState, action: ActionTypes): AlertsState {
  switch (action.type) {
    case ActionType.SET_ALERTS_BY_ID: {
      const alertParams = action.payload;
      const newAlertParams = new Map(state.alertsById);
      const newAlertsByLocationId = new Map(state.alertsByLocationId);

      alertParams.forEach((alertParam) => {
        newAlertParams.set(alertParam.id, alertParam);

        if (alertParam.alerts.length > 0) {
          // Add ID to location map if it has alerts
          const existingIds = newAlertsByLocationId.get(alertParam.location) ?? [];

          if (!existingIds.includes(alertParam.id)) {
            newAlertsByLocationId.set(alertParam.location, [...existingIds, alertParam.id]);
          }
        } else {
          // Remove ID from location map if alerts are empty
          const existingIds = newAlertsByLocationId.get(alertParam.location);

          if (existingIds) {
            const filteredIds = existingIds.filter((id) => id !== alertParam.id);

            if (filteredIds.length > 0) {
              newAlertsByLocationId.set(alertParam.location, filteredIds);
            } else {
              // Clean up the location key entirely if no IDs remain
              newAlertsByLocationId.delete(alertParam.location);
            }
          }
        }
      });

      return {
        ...state,
        alertsById: newAlertParams,
        alertsByLocationId: newAlertsByLocationId,
      };
    }

    case ActionType.SET_ALERTS_BY_LOCATION_ID: {
      const alertTree = action.payload;
      const newAlertsByLocationId = new Map(state.alertsByLocationId);
      const locId: string | undefined =
        alertTree.locations[0]?.location ?? alertTree.sensors[0]?.location;

      const existingIds = newAlertsByLocationId.get(locId) ?? [];

      const allNewIds: string[] = [
        ...alertTree.locations.map((l) => l.id),
        ...alertTree.sensors.map((s) => s.id),
      ];

      const allNewIdsSet = new Set(allNewIds);
      const existingIdsSet = new Set(existingIds);

      const updatedIds = [
        ...existingIds.filter((id) => allNewIdsSet.has(id)), // existing ids, but ONLY if still in new list (drops missing ones)
        ...allNewIds.filter((id) => !existingIdsSet.has(id)), // brand-new ids not previously tracked
      ];

      newAlertsByLocationId.set(locId, updatedIds);

      return {
        ...state,
        alertsByLocationId: newAlertsByLocationId,
      };
    }

    default: {
      return state;
    }
  }
}
